export const formatDateString = (dateToFormat: Date | string): string => {
  const date = new Date(dateToFormat);
  const day = date.toLocaleDateString('en-US', { day: 'numeric' });
  const month = date.toLocaleDateString('en-US', { month: 'short' });
  const year = date.toLocaleDateString('en-US', { year: 'numeric' });

  return `${day} ${month} ${year}`;
};
